import { z } from 'zod';


function isValidTime(value: string): boolean {
  const match = value.match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?$/);
  if (!match) return false;
  const hours = Number(match[1]);
  const minutes = Number(match[2]);
  const seconds = Number(match[3] ?? '0');
  return hours <= 23 && minutes <= 59 && seconds <= 59;
}

export const createFractionalLeaveFormSchema = z.object({
  name: z
    .string()
    .min(1, 'fractionalLeave:validation.nameRequired')
    .max(100, 'fractionalLeave:validation.nameMaxLength'),
  description: z
    .string()
    .min(1, 'fractionalLeave:validation.descriptionRequired'),
  hours: z
    .string()
    .refine(
      (value) => value === '' || isValidTime(value),
      'fractionalLeave:validation.hoursInvalidFormat',
    )
    .default(''),
  deductible: z.boolean().default(false),
});

export type CreateFractionalLeaveFormValues = z.infer<typeof createFractionalLeaveFormSchema>;
